import React, {useEffect, useState, useMemo}		from 'react';
import moment										from 'moment';

import Checkbox										from '../Checkbox';
import Modal										from '../Modal';
import Icon											from '../Icon';
import Load											from '../Load';
import Input										from '../Input';
import Textarea										from '../Textarea';
import Select										from '../Select';
import Badge										from '../Badge';
import Button										from '../Button';
import MultiInputContainer							from '../Input/MultiInputContainer';

import {useAppDispatch, useAppSelector}				from '../../../app/hooks';
import {LanguageNotification, LanguageType}			from '../../language/type';
import {MdmDeviceGroupJamf, MdmDevice,
	PutMdmDeviceCommand, JamfProtectData}			from '../../../redux/devices/interfaceMdm';
import {Device, DevicesState}						from '../../../redux/devices/interface';
import {InputValues}								from '../Input/interface';

import {ft_genNotification, ft_pushNotification}	from '../../functions/notification';
import {ft_getDeviceType}							from '../../functions/deviceFunction';
import {ft_formatFirstUpperCase}					from '../../functions/format';
import ft_cssVar									from '../../functions/getCssVar';
import {ft_setVarText}								from '../../functions/text';

import {regex_password}								from '../../data/regex';

import img_settings									from '../../images/icon/menu/settings.svg';
import img_refresh									from '../../images/icon/refresh.svg';
import img_download									from '../../images/icon/download.svg';

import * as API										from '../../API';
import LANGUAGE										from '../../language';


interface Props {
	modalCommand: keyof LanguageType['devices']['mdm']['actions']
	onClose: () => void
	editData?: Device
	mdmDeviceList?: MdmDevice[]
	mdmName: keyof DevicesState['mdm']
	isWin?: boolean
	returnData?: (data: PutMdmDeviceCommand) => void
	version?: string,
	date?: {
		date: InputValues,
		hours: InputValues
	},
	jamfProtect?: JamfProtectData
}

interface AlertJson {
	match: {
		event: {
			scriptPath: string
			device: {
				serialNumber?: string,
			}
		},
		facts: {
			human: string,
			actions: {
				name: string,
				parameters?: {
					title: string,
					message: string
				}
			}[]
		}[]
	}
}

interface Account {
	name: string,
	isAdmin: boolean
}

interface Applications {
	name: string,
	version: string,
	bundle_id: string
}

type Commands = ('restart' | 'shutDown' | 'setConfiguration' | 'reset' | 'lock' | 'deleteAccount' | 'addAccount' | 'applications' | 'update' | 'compliance' | 'alerts');


function ModalAssign(props: Props) {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const devices = useAppSelector(state => state.devices.data);
	const devicesMdm = useAppSelector(state => state.devices.mdm);
	const lang = useAppSelector(state => state.settings.lang);
	let notificationId = useAppSelector(state => state.notifications.lastId);

	const [modalCommandStep, set_modalCommandStep] = useState(0);
	const [jamfGroups, set_jamfGroups] = useState<MdmDeviceGroupJamf[]>([]);
	const [jamfGroupSelect, set_jamfGroupSelect] = useState<string[]>([]);
	const [jamfAccounts, set_jamfAccounts] = useState<Account[]>([]);
	const [jamfApplications, set_jamfApplications] = useState<Applications[]>([]);
	const [jamfAccountSelect, set_jamfAccountSelect] = useState('');
	const [jamfAccountInput, set_jamfAccountInput] = useState<InputValues>('');
	const [jamfAccountPassword, set_jamfAccountPassword] = useState<InputValues>('');
	const [passwordConfirm, set_passwordConfirm] = useState<InputValues>('');
	const [jamfAccountAdmin, set_jamfAccountAdmin] = useState(false);
	const [jamfAccountReset, set_jamfAccountReset] = useState(false);
	// const [jamfAccountUninstall, set_jamfAccountUninstall] = useState(false);
	const [load, set_load] = useState(false);

	const [lockPin, set_lockPin] = useState<InputValues>('');
	const [lockDescription, set_lockDescription] = useState<InputValues>('');

	const [confirm, set_confirm] = useState(false);

	const [modalApplication, set_modalApplication] = useState(false);
	const [selectedApp, set_selectedApp] = useState<{appName: string, bundleId: string}[]>([]);

	const [dateView, set_dateView] = useState(false);
	const [date, set_date] = useState<InputValues>(props.date?.date || '');
	const [hours, set_hours] = useState<InputValues>(props.date?.hours || '');

	const [complianceError, set_complianceError] = useState(false);
	const [complianceModal, set_complianceModal] = useState<JamfProtectData['scorecard'][number] | undefined>(undefined);

	const commmandName: Commands = useMemo(() => {
		if (props.modalCommand === 'shutDown_short')
			return 'shutDown';
		if (props.modalCommand === 'restart_short' || props.modalCommand === 'erase')
			return 'restart';
		return props.modalCommand;
	}, [props.modalCommand]);

	const TEXTE = LANGUAGE(lang);

	useEffect(() => {
		if (commmandName !== 'setConfiguration' || props.mdmName !== 'jamf')
			return;

		let type = '';

		if (props.editData)
			type = ft_getDeviceType(props.editData);
		else if (props.mdmDeviceList?.[0])
			type = props.mdmDeviceList[0].type;

		if (!type)
			return;

		set_load(true);

		API.getMdmDeviceGroupsJamf(type !== 'computer', user)
		.then((response) => {
			const groups: MdmDeviceGroupJamf[] = response?.data || [];

			if (props.editData) {
				const connectedJamf = devicesMdm[props.mdmName].find(find => find.serial === props.editData?.serial);

				set_jamfGroupSelect(groups.filter(find => find.computers?.some(e => e.id === connectedJamf?.id) || find.mobile_devices?.some(e => e.id === connectedJamf?.id)).map(e => e.id));
			}

			set_jamfGroups(groups);
			set_modalCommandStep(0);
			set_load(false);
		});
	}, []);

	useEffect(() => {
		if (!props.editData)
			return;

		if (commmandName === 'deleteAccount' && props.mdmName === 'vmWare') {
			API.getMdmDeviceAccountsVmWare(props.editData.serial, user)
			.then((response) => {
				set_jamfAccounts(response.data);
				set_modalCommandStep(0);
				set_load(false);
			});
		}

		if (!['deleteAccount', 'applications', 'addAccount'].some(f => f === commmandName) || props.mdmName !== 'jamf')
			return;

		const connectedMdm = devicesMdm[props.mdmName].find(find => find.serial === props.editData?.serial);

		if (!connectedMdm)
			return;

		set_load(true);

		API.getMdmDeviceSpecificDataJamf(commmandName !== 'deleteAccount' ? 'applications' : 'accounts', connectedMdm.id, connectedMdm.serial, connectedMdm.type, user)
		.then((response) => {
			if (!response.data)
				return;

			if (commmandName !== 'deleteAccount')
				set_jamfApplications(response.data);
			else
				set_jamfAccounts(response.data);
			set_modalCommandStep(0);
			set_load(false);
		});
	}, []);

	async function setMdmGroup(connectedJamf: MdmDevice) {
		const device = props.editData || devices.find(find => find.serial === connectedJamf.serial);

		if (!device)
			return false;

		const removeList = jamfGroups.filter(find => !jamfGroupSelect.some(f => f === find.id) && (find.computers?.some(e => e.id === connectedJamf.id) || find.mobile_devices?.some(e => e.id === connectedJamf.id)));
		const isMobile = ft_getDeviceType(device) !== 'computer';

		if (removeList.length > 0)
			await API.putMdmDeviceGroupsJamf(removeList.map(e => e.id), {idRemove: device._id}, isMobile, user);

		const response = await API.putMdmDeviceGroupsJamf(jamfGroupSelect, {idAdd: device._id}, isMobile, user);
		return response.status;
	}

	async function sendMdmCommand(serial: string, data?: PutMdmDeviceCommand) {
		return new Promise((resolve, reject) => {
			const connectedMdm = devicesMdm[props.mdmName].find(find => find.serial === serial);
			let command = '';

			if (commmandName === 'restart')
				command = 'RESTART_DEVICE';
			else if (commmandName === 'shutDown')
				command = 'SHUT_DOWN_DEVICE';
			else if (commmandName === 'reset')
				command = 'ERASE_DEVICE';
			else if (commmandName === 'setConfiguration' && connectedMdm) {
				return setMdmGroup(connectedMdm)
				.then((succes) => {
					return succes ? resolve(true) : reject();
				});
			} else if (commmandName === 'lock')
				command = 'LOCK_DEVICE';
			else if (commmandName === 'deleteAccount')
				command = 'DELETE_USER';
			else if (commmandName === 'addAccount')
				command = 'ADD_USER';
			else if (commmandName === 'update')
				command = 'UPDATE';
			else if (commmandName === 'applications')
				command = 'UNINSTALL';

			if (!connectedMdm || !command)
				return reject();

			const apiCommandData: PutMdmDeviceCommand = {
				...data,
				command,
				lockPin,
				commmandName,
				lockDescription,
				isWin:   props.isWin,
				version: props.version,
				id:      connectedMdm.id,
				serial:  connectedMdm.serial
			};

			if (props.date) {
				const useDate = moment(date, 'DD/MM/YYYY');
				const [h, m] = hours.toString().split(':');

				useDate.set({hour: parseInt(h, 10), minute: parseInt(m, 10)});
				apiCommandData.date = useDate.toDate();
			}

			if (commmandName === 'deleteAccount')
				apiCommandData.account = jamfAccountSelect === 'selectManually' ? jamfAccountInput : jamfAccountSelect;
			if (commmandName === 'addAccount') {
				apiCommandData.account = jamfAccountInput;
				apiCommandData.password = jamfAccountPassword;
				apiCommandData.admin = jamfAccountAdmin;
				apiCommandData.forceReset = jamfAccountReset;
				// apiCommandData.uninstall = jamfAccountUninstall;
				apiCommandData.uninstallList = selectedApp;
			}

			if (props.returnData) {
				props.returnData(apiCommandData);
				return resolve(true);
			}

			API.putMdmDeviceCommand(props.mdmName, apiCommandData, connectedMdm.type !== 'computer', user)
			.then((response) => {
				if (response.status)
					return resolve(true);
				else if (response.error === 'Device does not support Restart Device command') {
					const notification = ft_genNotification(TEXTE, 'error', getActionIcon(), response.error, 'error');

					notificationId = ft_pushNotification(dispatch, notificationId, notification);
					return resolve(true);
				}
				reject(response?.error);
			});
		});
	}

	async function onClickConfirm(data?: PutMdmDeviceCommand) {
		if (props.date && !dateView)
			return set_dateView(true);
		set_load(true);

		try {
			if (props.editData)
				await sendMdmCommand(props.editData.serial, data);
			else if (props.mdmDeviceList)
				await Promise.all(props.mdmDeviceList.map(e => sendMdmCommand(e.serial, data)));

			if (props.returnData)
				return props.onClose();

			const notificationName = `mdmAction${ft_formatFirstUpperCase(commmandName)}Success`;
			const notification = ft_genNotification(TEXTE, notificationName as keyof LanguageNotification, getActionIcon());

			ft_pushNotification(dispatch, notificationId, notification);
			props.onClose();
		} catch (err) {
			const notification = ft_genNotification(TEXTE, 'error', getActionIcon(), err as string, 'error');

			ft_pushNotification(dispatch, notificationId, notification);
		}
		set_load(false);
	}

	function getActionIcon() {
		let icon = img_settings;

		if (commmandName === 'restart')
			icon = img_refresh;
		if (commmandName === 'setConfiguration')
			icon = img_download;
		return icon;
	}

	function renderLockCommand() {
		function onChangePin(newValue: string) {
			newValue = newValue.replace(/\D/g, '').slice(0, 6);

			set_lockPin(newValue);
		}

		if (commmandName === 'applications' || commmandName === 'compliance' || commmandName === 'alerts')
			return <></>;

		return (
			<Modal
				fullWidth
				confirmLoad={load}
				onClose={props.onClose}
				cancelButton={props.onClose}
				confirmButton={() => onClickConfirm()}
				confirmButtonDisabled={
					(lockPin as string).length !== 6 || (lockPin as string).startsWith('0')
					|| (lockDescription as string).length > 256
				}
				header={
					<Icon
						size={40}
						iconBorder
						iconSize={18}
						borderSize={8}
						type={'warning'}
						icon={getActionIcon()}
						iconColor={[ft_cssVar('warning-600'), ft_cssVar('warning-600')]}
					/>
				}
			>
				<span className={'text-lg weight-600 gray-900'}>{title}</span>
				<span>{TEXTE.devices.mdm.actionsText[`${commmandName}Text`]}</span>
				<br />

				<Input
					value={lockPin}
					onChange={val => onChangePin(val as string)}
					title={TEXTE.devices.mdm.actionsText.lockInput}
					error={lockPin.toString().startsWith('0') ? TEXTE.devices.mdm.actionsText.lockError : undefined}
				/>

				<br />
				<span>{TEXTE.devices.mdm.actionsText.lockDescription}</span>
				<br />

				<Textarea
					resize
					maxChar={256}
					value={lockDescription}
					onChange={set_lockDescription}
					title={TEXTE.devices.mdm.actionsText.lockDescriptionInput}
				/>
			</Modal>
		);
	}

	function renderApplications() {
		const renderTable: React.ReactElement[] = [];

		jamfApplications.forEach((app, i) => {
			if (modalApplication && (app.bundle_id.startsWith('com.apple') || app.bundle_id.startsWith('com.jamf')))
				return;

			const index = selectedApp?.findIndex(f => f.bundleId === app.bundle_id);

			renderTable.push(
				<tr
					key={i}
					className={index !== -1 ? 'tableRow selected' : ''}
					onClick={() => {
						if (!modalApplication)
							return;

						const copy = [...selectedApp];

						if (index === -1)
							copy.push({appName: app.name?.replace('.app', ''), bundleId: app.bundle_id});
						else
							copy.splice(index, 1);

						set_selectedApp(copy);
					}}
				>
					{modalApplication &&
						<td><Checkbox active={index !== -1} /></td>
					}
					<td>{app.name?.replace('.app', '')}</td>
					<td>{app.version}</td>
					<td>{app.bundle_id}</td>
					{!modalApplication &&
						<td>
							{(!app.bundle_id.startsWith('com.apple') && !app.bundle_id.startsWith('com.jamf')) &&
								<Button
									size={'sm'}
									onClick={() => onClickConfirm({appName: app.name?.replace('.app', ''), bundleId: app.bundle_id})}
								>{TEXTE.devices.mdm.uninstall}</Button>
							}
						</td>
					}
				</tr>
			);
		});

		return (
			<Modal
				fullWidth
				confirmLoad={load}
				header={modalApplication ? TEXTE.devices.mdm.uninstallCheck : title}
				confirmButton={modalApplication ? () => set_modalApplication(false) : undefined}
				onClose={() => (modalApplication ? set_modalApplication(false) : props.onClose())}
			>
				<table className={'importTable'}>
					<thead>
						<tr style={{textAlign: 'left'}}>
							{modalApplication && <th />}
							<th>{TEXTE.global.name}</th>
							<th>{TEXTE.devices.mdm.version}</th>
							<th>{TEXTE.devices.mdm.bundleId}</th>
							{!modalApplication && <th>{TEXTE.global.action}</th>}
						</tr>
					</thead>
					<tbody>
						{renderTable}
					</tbody>
				</table>
			</Modal>
		);
	}

	function renderCompliances() {
		const renderTable: React.ReactElement[] = [];

		props.jamfProtect?.scorecard?.forEach((card, i) => {
			if (complianceError && card.pass)
				return;

			renderTable.push(
				<tr
					key={i}
					style={{cursor: 'pointer'}}
					onClick={() => set_complianceModal(card)}
				>
					<td>
						<Badge
							size={'sm'}
							color={card.pass ? 'success' : 'error'}
							text={card.pass ? TEXTE.devices.mdm.historySuccess : TEXTE.devices.mdm.historyError}
						/>
					</td>
					<td>{card.label}</td>
					<td>{card.section}</td>
					<td>{card.tags.join(', ')}</td>
				</tr>
			);
		});

		return (
			<Modal
				fullWidth
				header={title}
				confirmLoad={load}
				onClose={props.onClose}
			>
				<Checkbox active={complianceError} onChange={set_complianceError} text={TEXTE.devices.mdm.onlyError} />
				<br />

				<table className={'importTable'}>
					<thead>
						<tr style={{textAlign: 'left'}}>
							<th style={{width: 50}}>{TEXTE.global.status}</th>
							<th>{TEXTE.global.name}</th>
							<th>{TEXTE.devices.mdm.group}</th>
							<th>{TEXTE.devices.mdm.level}</th>
						</tr>
					</thead>
					<tbody>
						{renderTable}
					</tbody>
				</table>

				{complianceModal &&
					<Modal
						fullWidth
						header={<div className={'flex-center'}>
							{complianceModal.label}
							&nbsp;
							<Badge
								size={'sm'}
								color={complianceModal.pass ? 'success' : 'error'}
								text={complianceModal.pass ? TEXTE.devices.mdm.historySuccess : TEXTE.devices.mdm.historyError}
							/>
						</div>}
						confirmLoad={load}
						onClose={() => set_complianceModal(undefined)}
					>
						<Badge
							size={'sm'}
							color={'gray'}
							text={complianceModal.tags?.[0]}
						/>
						<br />
						<span>{complianceModal.description}</span>
					</Modal>
				}
			</Modal>
		);
	}

	function renderAlerts() {
		const renderTable: React.ReactElement[] = [];

		props.jamfProtect?.alerts?.forEach((alert, i) => {
			const fullData: AlertJson = JSON.parse(alert.json);
			const facts = fullData.match.facts?.[0];
			let actions: AlertJson['match']['facts'][number]['actions'][number] | undefined;

			if (facts)
				actions = facts.actions.find(f => f.parameters);

			renderTable.push(
				<tr key={i}>
					<td>{moment(alert.created).format('DD/MM/YY HH:mm:ss')}</td>
					<td>{alert.severity}</td>
					<td>{alert.status}</td>
					<td>
						<ul>
							<li>{facts?.human}</li>
							{actions && <li>{actions?.parameters?.title}</li>}
						</ul>
					</td>
					<td>
						{facts?.human === 'A removable storage device has been detected' ?
							`${TEXTE.global.serial}: ${fullData.match.event.device.serialNumber}`
							:
							actions?.parameters?.message
						}
					</td>
				</tr>
			);
		});

		return (
			<Modal
				fullWidth
				header={title}
				confirmLoad={load}
				onClose={props.onClose}
			>
				<table className={'importTable'}>
					<thead>
						<tr style={{textAlign: 'left'}}>
							<th style={{width: 150}}>{TEXTE.devices.mdm.date}</th>
							<th>{TEXTE.devices.mdm.level}</th>
							<th>{TEXTE.global.status}</th>
							<th>{TEXTE.devices.mdm.message}</th>
							<th>{TEXTE.global.description}</th>
						</tr>
					</thead>
					<tbody>
						{renderTable}
					</tbody>
				</table>
			</Modal>
		);
	}

	function renderDateView() {
		return (
			<Modal
				confirmLoad={load}
				onClose={props.onClose}
				cancelButton={props.onClose}
				confirmButton={() => onClickConfirm()}
				confirmButtonDisabled={!date || !hours}
				header={
					<Icon
						size={40}
						iconBorder
						iconSize={18}
						borderSize={8}
						type={'warning'}
						icon={getActionIcon()}
						iconColor={[ft_cssVar('warning-600'), ft_cssVar('warning-600')]}
					/>
				}
			>
				<span>{TEXTE.devices.mdm.actionDate}</span>
				<br />
				<Input
					required
					type={'date'}
					value={date}
					onChange={set_date}
					title={TEXTE.devices.mdm.dateInput}
				/>
				<br />
				<Input
					required
					type={'time'}
					value={hours}
					onChange={set_hours}
					title={TEXTE.devices.mdm.hours}
				/>
				<br />
			</Modal>
		);
	}

	let title = TEXTE.devices.mdm.actionsText[`${commmandName}Title`];

	if (dateView)
		return renderDateView();

	if (commmandName === 'setConfiguration' && modalCommandStep === 0) {
		const render: React.ReactElement[] = [];

		jamfGroups.forEach((group) => {
			const onClickGroup = () => {
				const copy = [...jamfGroupSelect];

				if (index === -1)
					copy.push(group.id);
				else
					copy.splice(index, 1);

				set_jamfGroupSelect(copy);
			};
			const index = jamfGroupSelect.findIndex(f => f === group.id);

			render.push(
				<div
					onClick={onClickGroup}
					className={`globalDataContainerItem deviceMdmGroupListItem ${index !== -1 && 'active'}`}
				>
					<Checkbox active={index !== -1} />
					<span>{group.name}</span>
				</div>
			);
		});

		return (
			<Modal
				fullWidth
				onClose={props.onClose}
				cancelButton={props.onClose}
				confirmButton={() => set_modalCommandStep(1)}
				confirmButtonDisabled={load || !jamfGroupSelect}
				header={
					<Icon
						size={40}
						iconBorder
						iconSize={18}
						borderSize={8}
						type={'success'}
						icon={img_settings}
						iconColor={[ft_cssVar('success-600'), ft_cssVar('success-600')]}
					/>
				}
			>
				<span className={'text-lg weight-600 gray-900'}>{TEXTE.devices.mdm.selectConfiguration}</span>
				<span>{TEXTE.devices.mdm.selectConfigurationText}</span>

				{load ? <Load center /> : render}
			</Modal>
		);
	}

	if (commmandName === 'deleteAccount' && modalCommandStep === 0) {
		const render: React.ReactElement[] = [];

		jamfAccounts.forEach((account) => {
			render.push(
				<div
					onClick={() => set_jamfAccountSelect(account.name === jamfAccountSelect ? '' : account.name)}
					className={`globalDataContainerItem deviceMdmGroupListItem ${jamfAccountSelect === account.name && 'active'}`}
				>
					<Checkbox round active={jamfAccountSelect === account.name} />
					{account.isAdmin && <Badge size={'sm'} color={'primary'} text={TEXTE.devices.mdm.admin} />}
					<span>{account.name}</span>
				</div>
			);
		});

		render.push(
			<>
				<br />
				<span>
					{'La liste précédente est mise à jour de manière hebdomadaire. Elle peut donc être inexacte au moment de votre consultation.'}<br />
					{'Si vous ne trouvez pas l’utilisateur à supprimer, vous pouvez écrire manuellement son nom d’utilisateur dans la barre suivante :'}
				</span>
				<div
					onClick={() => set_jamfAccountSelect('selectManually')}
					className={`globalDataContainerItem deviceMdmGroupListItem ${jamfAccountSelect === 'selectManually' && 'active'}`}
				>
					<Checkbox round active={jamfAccountSelect === 'selectManually'} />
					<Input
						value={jamfAccountInput}
						onChange={set_jamfAccountInput}
						placeholder={TEXTE.devices.mdm.selectAccountManual}
					/>
				</div>
			</>
		);

		return (
			<Modal
				fullWidth
				onClose={props.onClose}
				cancelButton={props.onClose}
				confirmButton={() => set_modalCommandStep(1)}
				confirmButtonDisabled={load || !jamfAccountSelect || (jamfAccountSelect === 'selectManually' && !jamfAccountInput)}
				header={
					<Icon
						size={40}
						iconBorder
						iconSize={18}
						borderSize={8}
						type={'success'}
						icon={img_settings}
						iconColor={[ft_cssVar('success-600'), ft_cssVar('success-600')]}
					/>
				}
			>
				<span className={'text-lg weight-600 gray-900'}>{TEXTE.devices.mdm.selectAccount}</span>
				<span>{TEXTE.devices.mdm.selectAccountText}</span>

				{load ? <Load center /> : render}
			</Modal>
		);
	}

	if (commmandName === 'addAccount' && modalCommandStep === 0) {
		if (modalApplication)
			return renderApplications();

		let passError: boolean | string = Boolean(jamfAccountPassword && !regex_password.test(jamfAccountPassword as string));

		if (jamfAccountPassword && jamfAccountPassword.toString().toLocaleLowerCase().includes(jamfAccountInput.toString().toLocaleLowerCase()))
			passError = TEXTE.settings.passwordRules.inludeUsername;

		return (
			<Modal
				gap={16}
				fullWidth
				onClose={props.onClose}
				cancelButton={props.onClose}
				confirmButton={() => set_modalCommandStep(1)}
				confirmButtonDisabled={!jamfAccountInput || !jamfAccountPassword || Boolean(passError) || jamfAccountPassword !== passwordConfirm}
				header={
					<Icon
						size={40}
						iconBorder
						iconSize={18}
						borderSize={8}
						type={'success'}
						icon={img_settings}
						iconColor={[ft_cssVar('success-600'), ft_cssVar('success-600')]}
					/>
				}
			>
				<span>
					<span className={'text-lg weight-600 gray-900'}>{TEXTE.devices.mdm.addAccount}</span><br />
					<span>{TEXTE.devices.mdm.addAccountText}</span>
				</span>

				<Select
					value={jamfAccountAdmin ? 2 : 1}
					title={TEXTE.devices.mdm.addAccountType}
					onChange={val => set_jamfAccountAdmin(val === 2)}
					data={[
						{value: 1, render: TEXTE.devices.mdm.guest},
						{value: 2, render: TEXTE.devices.mdm.admin}
					]}
				/>

				<Input
					required
					value={jamfAccountInput}
					title={TEXTE.global.username}
					onChange={val => set_jamfAccountInput(props.mdmName === 'vmWare' ? val.toString().replace(/ /g, '') : val)}
				/>

				<MultiInputContainer>
					<Input
						required
						type={'password'}
						placeholder={'******'}
						style={{marginBottom: 8}}
						value={jamfAccountPassword}
						title={TEXTE.global.password}
						autoComplete={'new-password'}
						onChange={set_jamfAccountPassword}
						error={passError}
					>
						<div className={'settingsPasswordRules'}>
							<span>{TEXTE.settings.passwordRules.text}</span>
							{TEXTE.settings.passwordRules.rules.map((e, i) => <span key={`rules-${i}`}>{e}</span>)}
						</div>
					</Input>

					<Input
						type={'password'}
						value={passwordConfirm}
						onChange={set_passwordConfirm}
						title={TEXTE.login.confirmPassword}
						error={!!((jamfAccountPassword || passwordConfirm) && jamfAccountPassword !== passwordConfirm)}
					/>
				</MultiInputContainer>

				<Checkbox
					active={jamfAccountReset}
					onChange={set_jamfAccountReset}
					text={TEXTE.devices.mdm.resetPassword}
				/>
				{user?.company === '66a79904f8a4bcd43536e943' &&
				<Checkbox
					active={selectedApp.length > 0}
					text={TEXTE.devices.mdm.uninstallCheck}
					onChange={() => set_modalApplication(true)}
				/>
				}
			</Modal>
		);
	}

	if (commmandName === 'applications')
		return renderApplications();
	if (commmandName === 'compliance')
		return renderCompliances();
	if (commmandName === 'alerts')
		return renderAlerts();

	if (commmandName === 'setConfiguration')
		title = ft_setVarText(title, jamfGroups.filter(find => jamfGroupSelect.some(f => f === find.id)).map(e => e.name).join(', '));
	if (commmandName === 'deleteAccount' || commmandName === 'addAccount')
		title = ft_setVarText(title, (jamfAccountSelect === 'selectManually' || commmandName === 'addAccount') ? jamfAccountInput : jamfAccountSelect);

	if (commmandName === 'lock' && !props.isWin)
		return renderLockCommand();

	const needCheck = props.mdmName === 'jamf' && ['addAccount', 'update'].some(f => f === commmandName);

	return (
		<Modal
			confirmLoad={load}
			onClose={props.onClose}
			cancelButton={props.onClose}
			confirmButton={() => onClickConfirm()}
			confirmButtonDisabled={needCheck && !confirm}
			header={
				<Icon
					size={40}
					iconBorder
					iconSize={18}
					borderSize={8}
					type={'warning'}
					icon={getActionIcon()}
					iconColor={[ft_cssVar('warning-600'), ft_cssVar('warning-600')]}
				/>
			}
		>
			<span className={'text-lg weight-600 gray-900'}>{title}</span>
			<span>{TEXTE.devices.mdm.actionsText[`${commmandName}Text`]}</span>
			<br />
			{needCheck &&
				<Checkbox
					active={confirm}
					onChange={set_confirm}
					text={TEXTE.devices.mdm.actionsText.addAccountCheck}
				/>
			}
		</Modal>
	);
}

export default ModalAssign;
